import GoogleAutoComplete from '@/components/google-autocomplete'
import { Button } from '@/components/ui/button'
import { Address } from '@/types'
import { Copy, Edit, MapPin, Trash2 } from 'lucide-react'
import React from 'react'

const LocationItem = ({
  locale = 'en',
  location,
  removeOnly = false,
  handleRemove,
  onChange,
  placeholder,
}: {
  locale?: string
  location: Address | undefined
  removeOnly?: boolean
  handleRemove: () => void
  onChange: (value: Address) => void
  placeholder?: string
}) => {
  if (!location) {
    return (
      <GoogleAutoComplete
        locale={locale}
        setAddress={onChange}
        placeholder={placeholder}
      />
    )
  }

  return (
    <div className="flex justify-between items-center border-1 border p-3 rounded-lg">
      <div className="flex items-center space-x-2">
        <MapPin className="text-primary" />
        <div className="text-sm">
          <strong>{location.city}</strong>
          <p>{location.formattedAddress}</p>
        </div>
      </div>
      <div>
        {removeOnly ? null : (
          <>
            <Button
              size="icon"
              variant="ghost"
              className="rounded-full"
              type="button"
            >
              <Copy />
            </Button>

            <Button
              size="icon"
              variant="ghost"
              className="rounded-full"
              type="button"
            >
              <Edit />
            </Button>
          </>
        )}

        <Button
          size="icon"
          variant="ghost"
          className="rounded-full"
          type="button"
          onClick={handleRemove}
        >
          <Trash2 />
        </Button>
      </div>
    </div>
  )
}

export default LocationItem
